module.exports = __webpack_public_path__ + "static/media/notification.921894b0.mp3";